module.exports = __webpack_public_path__ + "static/img/question-mark.f4f31df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcImg/questionnaire/question-mark.png
// module id = K7Yt
// module chunks = 1